import { DataType } from './DataType';
import { EnterExitDailyRecord } from './sets/EnterExitDailyRecord';
import { EnterExitHourlyRecord } from './sets/EnterExitHourlyRecord';
import { VisitorsRecord } from './sets/VisitorsRecord';
import { Constructor } from 'vue/types/options';

export class TypeMappings {
    public static GetType(dt: DataType): Constructor {
        switch (dt) {
            case DataType.EnterExitDaily    : return EnterExitDailyRecord;
            case DataType.EnterExitHourly   : return EnterExitHourlyRecord;
            case DataType.VisitorsDaily     : return VisitorsRecord;
        }
        console.error("Unmapped type detected!");
    }
}